export default __webpack_public_path__ + "static/media/ellipsis_mega_big.80892e06.png";